import { cn } from "@utils/tw"
import { ContentBlock, ContentBlocks } from "eddev/blocks"

export const CenteredBlocks = ({ contentBlocks }: { contentBlocks?: ContentBlock[] }) => {
  return (
    <ContentBlocks
      blocks={contentBlocks}
      wrapBlock={(children, ctx) => {
        return (
          <div className={cn(ctx.current.flags?.fullWidth ? "w-full" : "grid-auto")}>
            <div className={cn("col-span-12", ctx.current.flags?.fullWidth ? "" : "md:col-span-6 md:col-start-4")}>
              {children}
            </div>
          </div>
        )
      }}
    />
  )
}
